export default {
  title: 'Ordini persi',
  card_title: 'E-mail per ordini persi',
  intro:
    "Se nessuno accetta un ordine entro {{minutes}} minuti, viene rifiutato automaticamente. Tutti gli indirizzi in questo elenco ricevono quindi un'e-mail con l'ordine, così qualcuno può intervenire.",
  default: {
    owner: 'Titolare del ristorante',
    partner: 'Partner',
    owner_missing: 'Il titolare del ristorante ({{email}}) non riceverà queste e-mail.',
    partner_missing: "L'indirizzo predefinito del partner ({{email}}) non riceverà queste e-mail.",
  },
  empty: "Nessuno verrebbe avvisato degli ordini persi. Aggiungi almeno un'e-mail per salvare.",
  save_error: 'Impossibile salvare le e-mail. Controlla la connessione e riprova.',
  load_error: 'Impossibile caricare le e-mail. Controlla la connessione e riprova.',
  unavailable: 'Le e-mail per ordini persi non sono disponibili per questo ristorante.',
  buttons: {
    save: 'Salva',
    retry: 'Riprova',
  },
  toasts: {
    saved: 'E-mail per ordini persi salvate',
  },
};
